'use strict';

var defined = require('./utils').defined;

var varint = require('varint');

function compileEncode(m, resolve, enc, oneofs, encodingLength) {
  var oneofsKeys = Object.keys(oneofs);
  var encLength = enc.length;
  var ints = {};

  for (var i = 0; i < encLength; i++) {
    ints[i] = {
      p: varint.encode(m.fields[i].tag << 3 | 2),
      h: varint.encode(m.fields[i].tag << 3 | enc[i].type)
    };
    var field = m.fields[i];
    m.fields[i].packed = field.repeated && field.options && field.options.packed && field.options.packed !== 'false';
  }

  function encodeField(buf, offset, h, e, packed, innerVal) {
    var j = 0;

    if (!packed) {
      for (j = 0; j < h.length; j++) {
        buf[offset++] = h[j];
      }
    }

    if (e.message) {
      varint.encode(e.encodingLength(innerVal), buf, offset);
      offset += varint.encode.bytes;
    }

    e.encode(innerVal, buf, offset);
    return offset + e.encode.bytes;
  }

  return function encode(obj, buf, offset) {
    if (offset == null) {
      offset = 0;
    }

    if (buf == null) {
      buf = Buffer.allocUnsafe(encodingLength(obj));
    }

    var oldOffset = offset;
    var objKeys = Object.keys(obj);
    var i = 0; // oneof checks

    var match = false;

    for (i = 0; i < oneofsKeys.length; i++) {
      var name = oneofsKeys[i];
      var prop = oneofs[i];

      if (objKeys.indexOf(prop) > -1) {
        if (match) {
          throw new Error('only one of the properties defined in oneof ' + name + ' can be set');
        }

        match = true;
      }
    }

    for (i = 0; i < encLength; i++) {
      var e = enc[i];
      var field = m.fields[i]; // was f

      var val = obj[field.name];
      var j = 0;

      if (!defined(val)) {
        if (field.required) {
          throw new Error(field.name + ' is required');
        }

        continue;
      }

      var p = ints[i].p;
      var h = ints[i].h;
      var packed = field.packed;

      if (field.map) {
        var tmp = Object.keys(val);

        for (j = 0; j < tmp.length; j++) {
          tmp[j] = {
            key: tmp[j],
            value: val[tmp[j]]
          };
        }

        val = tmp;
      }

      if (packed) {
        var packedLen = 0;

        for (j = 0; j < val.length; j++) {
          if (!Object.prototype.hasOwnProperty.call(val, j)) {
            continue;
          }

          packedLen += e.encodingLength(val[j]);
        }

        if (packedLen) {
          for (j = 0; j < h.length; j++) {
            buf[offset++] = p[j];
          }

          varint.encode(packedLen, buf, offset);
          offset += varint.encode.bytes;
        }
      }

      if (field.repeated) {
        var innerVal;

        for (j = 0; j < val.length; j++) {
          innerVal = val[j];

          if (!defined(innerVal)) {
            continue;
          }

          offset = encodeField(buf, offset, h, e, packed, innerVal);
        }
      } else {
        offset = encodeField(buf, offset, h, e, packed, val);
      }
    }

    encode.bytes = offset - oldOffset;
    return buf;
  };
}

module.exports = compileEncode;